import React from 'react'
import Navbar from '../components/Navbar'
import Baner from '../components/Baner'
import bg from '../assets/bg-hipoteczne.jpg'
import Footer from '../components/Footer'

const KredytyHipoteczne = () => {

  const rodzaje = [
    {
      id: 1,
      text: "Kredyt na zakup nieruchomości",
      text2: "Zakup nieruchomości, budowa domu w obecnych czasach to niełatwe wyzwanie dla inwestora. Na pewno dobrze trafiłeś – nasze wieloletnie doświadczenie i wiedza pozwoli poprowadzić twoją sprawę w jak najlepszy sposób. Powiedz nam czego oczekujesz, a my dzięki rozbudowanej sieci kontaktów i dostępowi do innowacyjnych narzędzi błyskawicznie znajdziemy dla Ciebie najlepsze rozwiązanie. Optymalne rozwiązanie to takie gdzie nie jesteś narażony wzrost stóp procentowych , a kiedy w przyszłości banki zaczną obniżać oprocentowanie ty również skorzystasz z tej opcji od razu. Po prostu zdecyduj się by Twoją sprawę poprowadził ekspert.",
    }, {
      id: 2,
      text: "Refinansowanie kredytu hipotecznego",
      text2: "Polityka kredytowa banków ale i również sytuacja osobisto – finansowa kredytobiorcy nie zawsze pozwala skorzystać z najlepszej opcji na rynku. Spłacasz kredyt a Twoje warunki budzą wątpliwości, poniosłeś duże koszta udzielenia kredytu . Nie zastanawiaj się , skontaktuj się z naszym ekspertem a poprowadzi on Twoją sprawę byś mógł odzyskać poniesione koszta udzielonego kredytu",
    }, {
      id: 3,
      text: "Pożyczka hipoteczna",
      text2: "Potrzebujesz wolnych środków ,chcesz obniżyć swoje obecne zobowiązania , posiadasz nieruchomość. Wolne środki na dowolny cel nawet do 70% wartości zabezpieczenia. W przypadku spłaty kredytów gotówkowych nawet do 90 % wartości zabezpieczenia. Skontaktuj się z naszym ekspertem",
    }, 
  ]

  return (
    <div>
      <Navbar />
      <Baner bg={bg} text="KREDYTY HIPOTECZNE" text2=""/>
      <div className='w-full'>
        <div className='justify-center flex mx-auto max-w-[1450px] bg-white'>
          <div className='text-center pt-10 lg:pt-20 px-10 lg:px-20'>
            {rodzaje.map((item) => (
              <div key={item.id} className='pt-10'>
                <h2 className='text-2xl font-semibold pb-2'>{item.text}</h2>
                <p>{item.text2}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default KredytyHipoteczne